import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loginReducerApi } from "../../constants/apiConstants";
import { decryptPayload, encryptPayload } from "../../utils/encrypt";
import request from "../../utils/request";
import Cookies from "js-cookie";
import { profileSettings } from "./profileSettingReducer";
// Async thunk for login
export const loginUser = createAsyncThunk(
    "loginReducer/loginUser",
    async (data, { dispatch }) => {
      const { payload, navigate, setError } = data;     
      try {
        // Encrypt the payload
        const encryptedPayload = encryptPayload(payload);
        
        // API request
        const res = await request({
          url: loginReducerApi.login,
          method: "POST",
          data: { data: encryptedPayload }, 
        });
       
        // Dispatch success response
        dispatch(loginUserRes(res));
   
        // Optionally handle navigation or cookies after login
        
        if (res?.data) {
          
          navigate("/content-analytics"); 
          dispatch(profileSettings({dispatch}));
          const decryptedString = decryptPayload(res?.data)
          Cookies.set("loginStatus", true, { path: "", expires: 365 });
          Cookies.set("authToken",decryptedString.accessToken,{expires:365,path:''});
          Cookies.set("refreshToken",decryptedString.refreshToken,{expires:365,path:''});
        }  else {
          setError("password", {message: res?.response})
        }
        return res; 
       
      } catch (error) {
        console.error("Login failed:", error);
        throw error;
      }
    }
  );
  
  // Slice 
  const loginSlice = createSlice({
    name: "loginReducer",
    initialState: {
      user: null,
      loading: false,
      error: null,
    },
    reducers: {
      loginUserRes: (state, action) => {
        state.user = action.payload; // Update user state with API response
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(loginUser.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(loginUser.fulfilled, (state, action) => {
          state.loading = false;
          state.user = action.payload;
        })
        .addCase(loginUser.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
    },
  });
  
  export const { loginUserRes } = loginSlice.actions;
  export default loginSlice.reducer;